import { IInventoryPage } from '../inventory-page.interface';


export const SUPPORT_PAGE: IInventoryPage = {
	'route': '/support',
	'title': 'Support',
	'uiReference': [
		'Join our Discord',
		'Email our team',
		'Report a problem'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/support/support-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/support/support/support.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/support/support/support.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/support/support/support.component.html'
	],
	'aliases': []
};
